import { noAuth, client } from './client'
import { tokenAuthorization } from '@/api/authorization'

const normalizeNumber = async (number, countryId) => {
  try {
    if (number.startsWith('00')) {
      number = number.replace('00', '+')
    }

    let resource = `/v1/phonenumbers/normalize?number=${encodeURIComponent(number)}`

    if (countryId) {
      resource += `&countryId=${countryId}`
    }

    let response = await noAuth.get(resource)

    if (response.data.countryId === 'DO') {
      if (response.data.endpoint.startsWith('+1809')) {
        response.data.countryCode = '1809'
      } else if (response.data.endpoint.startsWith('+1829')) {
        response.data.countryCode = '1829'
      } else if (response.data.endpoint.startsWith('+1849')) {
        response.data.countryCode = '1849'
      }
    }

    return response.data
  } catch (error) {
    throw error
  }
}

const createSession = async (token, expiresIn = 86400, version = { os: 'web browser', platform: 'web', application: 'Rebtel SPA' }) => {
  try {
    let response = await noAuth.post('/v1/instance/', {
      version: version,
      expiresIn: expiresIn
    }, {
      headers: {
        'Authorization': tokenAuthorization(token)
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

const deleteSession = async () => {
  try {
    let response = await noAuth.delete('/v1/instance/authorization', { data: null })
    return response.data
  } catch (error) {
    throw error
  }
}

const getCurrencies = async (voucherCode) => {
  try {
    let response = await client.get('/v1/currencies', {
    })
    return response.data.currencies
  } catch (error) {
    throw error
  }
}

export {
  normalizeNumber,
  createSession,
  deleteSession,
  getCurrencies
}



// WEBPACK FOOTER //
// ./src/api/base/index.js